<template>
  <click-outside :do="close">
    <div>
      <transition name="fade">
        <div v-if="isVisible" class="backdrop" @click="close"></div>
      </transition>
      <transition name="to-up">
        <div v-if="isVisible" class="fixed bottom-0 left-0 w-full bg-white z-40">
          <div class="w-full border-b-1 border-grey-light">
            <p class="uppercase text-sm py-4 text-left px-5">
              {{ $t('Accounts') }}
            </p>
          </div>
          <div class="flex items-center px-5 mt-6 mb-3">
            <span class="icon-user_icon text-black text-2xl" />
            <p class="ml-4">
              {{ currentInvestor.full_name }}
              &nbsp;<span class="text-grey-darker font-light">({{ $t('Primary') }})</span><br />
              <small>{{ currentInvestor.company.name }}</small>
            </p>
            <span class="icon-check-alt text-green text-4lg ml-auto" />
          </div>
          <div
            v-for="investor in investorsWithoutCurrent"
            :key="investor.id"
            @click="changeCurrentInvestor(investor)"
            class="flex items-center px-5 mb-4"
          >
            <span class="icon-user_icon text-black text-2xl" />
            <p class="ml-4 my-0">
              {{ investor.full_name }}<br />
              <small>{{ investor.company.name }}</small>
            </p>
          </div>
        </div>
      </transition>
    </div>
  </click-outside>
</template>

<script>
import ClickOutside from '@/components/shared/ClickOutside'
import { useInvestorStore } from '@/stores/investor'

export default {
  name: 'AccountsDropdown',
  components: { ClickOutside },

  setup () {
    const investorStore = useInvestorStore()

    return {
      investorStore
    }
  },

  props: {
    isVisible: { type: Boolean, default: false }
  },

  computed: {
    investors () {
      return this.investorStore.investors
    },
    currentInvestor () {
      return this.investorStore.currentInvestor
    },

    investorsWithoutCurrent () {
      return this.investors && this.investors.length > 1
        ? this.investors.filter(item => item.id !== this.currentInvestor.id)
        : []
    }
  },

  methods: {
    changeCurrentInvestor (investor) {
      this.investorStore.setCurrentInvestor(this.investors.find(item => item.id === investor.id))
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
